import { canGoBack } from '@repo/shared/navigation';
import { useRouterState } from '@tanstack/react-router';
import { useNavigate } from './useNavigate';

export function useModalState<TValue = boolean>(
	key: string,
	options: {
		parse?: (v: string) => TValue;
	} = {},
) {
	const { parse = (v) => !!v } = options;
	const navigate = useNavigate();
	// Select only the `modals` query param so that unrelated search changes don't re-render
	const rawModals = useRouterState({
		select: (s) => {
			return (s.location.search as Record<string, string>)[key];
		},
	});
	const current = parse(rawModals ?? '');

	return {
		value: current,
		setOpen: ({
			open,
			value = open ? true : undefined,
		}: {
			value?: unknown;
			open: boolean;
		}) => {
			if (!open && canGoBack()) {
				history.back();
				return;
			}
			// TODO: debug why navigating on home page is adding trailing slash
			navigate({
				back: !open,
				replace: !open,
				search: (prev) => ({
					...prev,
					[key]: typeof value === 'boolean' ? value : value && String(value),
				}),
				viewTransition: false,
			});
		},
	};
}
